<div class="container u-mt60 containerMyprofyleView">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-8">
      <h1 class="u-mb30 txt txt--title">
        Mi perfil
      </h1>
    </div>

    <section style="width: 100%">
      <app-person-card [boxColor]="personBoxColor" [usingAspect]="usingAspect" [completeUserData]="completeUserData">
      </app-person-card>
    </section>

    <div class="col-md-12">
      <div class="tabs tabs--orange">
        <input *ngIf="availableViews.includes('licenses')" class="state" type="radio" value="licenses" title="tab-one" [formControl]="currentViewControl" id="tab-one" />
        <input *ngIf="availableViews.includes('infractions')" class="state" type="radio" value="infractions" title="tab-two" [formControl]="currentViewControl" id="tab-two" />
        <input *ngIf="availableViews.includes('requests')" class="state" type="radio" value="requests" title="tab-three" [formControl]="currentViewControl" id="tab-three" />
        <div class="tabs__group flex-tabs container-tabs">
          <label *ngIf="availableViews.includes('licenses')" for="tab-one" id="tab-one-label" class="tab__item">Licencias registradas</label>
          <label *ngIf="availableViews.includes('infractions')" for="tab-two" id="tab-two-label" class="tab__item">Infracciones</label>
          <label *ngIf="availableViews.includes('requests')" for="tab-three" id="tab-three-label" class="tab__item">Historial de solicitudes</label>
          <div id="tab-one-panel" class="tab__panel active">
            <app-license-status *ngIf="userData" [userMdmid]="userData.mdmid"></app-license-status>
          </div>
          <div id="tab-two-panel" class="tab__panel">
            <app-infringement-status *ngIf="userData" [userMdmid]="userData.mdmid"></app-infringement-status>
          </div>
          <div *ngIf="userData" id="tab-three-panel" class="tab__panel">
            <app-request-status
              [detailRequestShow]="true"
              [showingDetailRequirementId]="sendedIdToShow"
              [userEmail]="userData.email"
              [userMdmId]="userData.mdmid"
              [shouldShowDeleteButtons]="true"
              [shouldShowDetailButtons]="true"
            ></app-request-status>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
